import { ArrowRightIcon } from '@synoptic/ui-kit/icons/react/arrow-right.js';
import { LinkButton } from '@synoptic/ui-kit/link-button/link-button.js';
import { Link } from '@/routes-utils/navigation';
import { paths } from '@/routes-utils/paths';
import {
  ctWrappedAbout,
  ctWrappedAboutDescription,
  ctWrappedAboutExploreButton,
  ctWrappedAboutLink,
  ctWrappedAboutTextContainer,
  ctWrappedAboutTitle,
} from './route.css';

export const CtStatsAbout = () => {
  return (
    <div className={ctWrappedAbout}>
      <div className={ctWrappedAboutTextContainer}>
        <h2 className={ctWrappedAboutTitle}>About project</h2>
        <p className={ctWrappedAboutDescription}>
          This project is created by <strong>Synoptic</strong>, intelligence and
          data <strong>marketplace</strong>. You can find many data feeds and
          scraping tools on our marketplace. For <strong>collaborations</strong>{' '}
          on our datasets reach out to{' '}
          <a className={ctWrappedAboutLink} href="mailto:info@synoptic.com">
            info@synoptic.com
          </a>{' '}
          or DM{' '}
          <a
            className={ctWrappedAboutLink}
            target="_blank"
            href="https://x.com/SynopticCom"
            rel="noreferrer"
          >
            @SynopticCom
          </a>{' '}
          on X.
        </p>
      </div>

      <LinkButton
        endIcon={<ArrowRightIcon />}
        size="medium"
        className={ctWrappedAboutExploreButton}
        asChild
      >
        <Link to={paths.landing}>Explore Synoptic</Link>
      </LinkButton>
    </div>
  );
};
